var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProfileBlack = function SvgProfileBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6235 39.1002H6.14262C6.4288 36.049 8.14044 32.8416 10.8485 30.3015C13.8131 27.5208 17.8952 25.6163 22.383 25.6163C26.8709 25.6163 30.953 27.5208 33.9176 30.3015C36.6256 32.8416 38.3373 36.049 38.6235 39.1002Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3799,
    cy: 15.3099,
    r: 10.3099,
    fill: "black"
  })));
};

export default SvgProfileBlack;